import { render, staticRenderFns } from "./table_expand.vue?vue&type=template&id=4a637b78&scoped=true&"
import script from "./table_expand.vue?vue&type=script&lang=js&"
export * from "./table_expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a637b78",
  null
  
)

export default component.exports